<template>
<div>
    <!-- fixed-bottom-nav -->
    <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 400px;">
        <div style="padding-left:1em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Timeline</span></a>
            <a href="/shop"><i class="fa fa-home"></i><br><span>Shop</span></a>
            <a href="/account"><i class="fa fa-user"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><br><span>Notifications</span></a>
            <a href="/cart"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <!-- <a href="#news" style="font-size:22px;"><i class="fa fa-plus"></i><span>Add</span></a> -->
        </div>
    </div>

    <!---mobile-->
    <div class="bottombar" style="margin-top:15em; margin-left: -2em;width: 150%;">
        <div style="margin-left:2.5em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Timeline</span></a>
            <!-- <a href="/shop"><i class="fa fa-home"></i><br><span>Shop</span></a> -->
            <a href="/account"><i class="fa fa-user"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><br><span>Notifications</span></a>
            <a href="/cart"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <a href="/account"><i class="fa fa-gear"></i><br><span>Settings</span></a>
            <!-- <a href="/account"><i class="fa fa-plus"></i><span>New</span></a> -->
        </div>
    </div>
    <!--./mobile-->
   
    <!--./ fixed-bottom-nav -->
 </div>
</template>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'MenuBottom',
    data () {
      return {
       
      }
  },
}
</script>


// WEBPACK FOOTER //
// menubottom.vue?0357d490